import React, { lazy, Suspense } from 'react';
import { Box, Flex } from '@wegroup/design-system';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import Header from './CompanyScanBottomBarDrawerHeader';
import LoadingSpinner from '../../../../../../../common/src/components/LoadingSpinner';
const Body = lazy(() => import('./CompanyScanBottomBarDrawerBody'));

interface Props {
  left: number;
  width: number;
}

const CompanyScanBottomBarDrawer: React.FC<React.PropsWithChildren<Props>> = ({
  left,
  width,
}) => {
  const { position } = useFlowsRouteParams();
  const height = position === 'overview' ? '100%' : 0;

  /** Prevent loading this big component when not needed */
  if (position !== 'overview') return null;

  return (
    <Box
      position="absolute"
      left="0"
      right="0"
      bottom="0"
      overflow="hidden"
      h={height}
      transition="0.3s"
      zIndex={2}
    >
      <Flex flexDir="column" bg="white" w="100%" h="100%">
        <Header />
        <Suspense fallback={<LoadingSpinner />}>
          <Body width={width} />
        </Suspense>
      </Flex>
    </Box>
  );
};

export default CompanyScanBottomBarDrawer;
